import React, { FC } from 'react'
import FundingQueContainer from 'containers/Ques/Funding'

const FundingQue: FC = () => <FundingQueContainer />

export default FundingQue
